<div
  *transloco="let t; prefix: uiKitScope"
  class="ui-form-color-picker d-flex align-items-center gap-2"
>
  <input
    type="color"
    class="color-swatch"
    [value]="safeSwatchValue()"
    (input)="onChange($any($event.target).value)"
  />
  <input
    type="text"
    class="form-control hex-input"
    maxlength="7"
    [value]="value()"
    (input)="onChange($any($event.target).value)"
  />
  @if (hasError()) {
    <span class="text-danger small">
      {{ invalidMessage() || t('validation.invalidHex') }}
    </span>
  }
</div>
